import type * as React from "react";
import { cn } from "../../lib/cn";

export interface TextareaProps extends React.ComponentProps<"textarea"> {
  error?: boolean;
}

export function Textarea({
  className,
  error,
  "aria-invalid": ariaInvalid,
  ...props
}: TextareaProps) {
  const isInvalid = error || ariaInvalid === true || ariaInvalid === "true";

  return (
    <textarea
      aria-invalid={isInvalid ? true : undefined}
      className={cn(
        "flex min-h-[5rem] w-full rounded-md border bg-container-default-background px-3 py-2 text-body-m-r placeholder:text-text-placeholder transition-colors duration-140 ease-emphasized focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        isInvalid
          ? "border-fail-text text-fail-text focus-visible:border-fail-text"
          : "border-container-default-border text-text focus-visible:border-primary",
        className,
      )}
      {...props}
    />
  );
}
